<template>
  <div class="search-from">
    <el-form class="search-from-content">
      <div v-for="(item, key) in   formItems  " class="search-from-item" :key="key">
        <section class="section" v-show="item.show ? item.show(searchData) : true">
          <el-form-item v-if="item.type == 'input'">
            <el-input v-model.trim="searchData[item.fieldName]" :disabled="item.disabled" :placeholder="item.name" clearable maxlength="20" size="small" v-bind=" item.$attrs " :style="
              item.width ? `width: ${item.width}px` : ` width:${defaultWidth}px`
            " />
          </el-form-item>
          <el-form-item v-if=" item.type == 'select' ">
            <el-select v-model=" searchData[item.fieldName] " size="small" :placeholder=" `${item.name}` "
              style="width: 100%" :disabled=" item.disabled " clearable v-bind=" item.$attrs " :style="
                item.width ? `width: ${item.width}px` : ` width:${defaultWidth}px`
              ">
              <el-option v-for="  e   in   item.select  " :label=" e.name " :value=" e.id " :key=" e.id "></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label=" item.name " v-if=" item.type == 'daterange'  " :label-width="item.labelWidth ? item.labelWidth +'px': '120px'">
            <el-date-picker v-model=" searchData[item.fieldName] " value-format="yyyy-MM-dd" size="small" clearable
              type="daterange" range-separator="-" :start-placeholder=" item.startName ? item.startName : '开始日期' "
              :end-placeholder=" item.endName ? item.endName : '结束日期' " v-bind=" item.$attrs "
              :style=" item.width ? `width: ${item.width}px;` : '' ">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label=" item.name " v-if=" item.type == 'date' " :label-width="item.labelWidth ? item.labelWidth +'px':'120px'">
            <el-date-picker v-model=" searchData[item.fieldName] " value-format="yyyy-MM-dd" size="small" clearable
              type="date" v-bind=" item.$attrs " :style=" item.width ? `width: ${item.width}px;` : '' ">
            </el-date-picker>
          </el-form-item>
        </section>
      </div>
      <el-form-item class="search-from-item-btns">
        <el-button size="small" type="primary" @click=" search ">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click=" reset ">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="form-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>

export default {
  components: {},
  model: {
    prop: 'searchData',
    event: 'input'
  },
  props: {
    formItems: {
      type: Array,
      default: () => []
    },
    searchData: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      defaultWidth: 140,
    };
  },
  filters: {},
  created() {
  },
  mounted() { },
  methods: {
    // 搜索
    search() {
      this.$emit("search");
    },
    // 重置
    reset() {
      this.$emit("reset");
    },
  },
};
</script>
<style lang="scss" scoped>
.search-from {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  &-content {
    display: flex;
    align-items: baseline;
    flex: 1;
  }
  .section{
    margin-right: 10px;
  }
  ::v-deep {
    .el-form-item__content {
      line-height: 32px;
    }
  }
}

.form-right {
  display: flex;
  align-items: baseline;
  margin-left: 8px;
}

.search-from-item {

}
.search-from-item-btns{
  margin-right: 8px;
}
</style>
